<template>
    <div class="row mt-5">
        <div class="col-12 mb-5">
            <label class="form-label" for="start_date">
                {{ $trans.get('__JSON__.Start Date and Time') }}
            </label>
            <div class="input-group">
                <flat-pickr id="start_date" class="form-control" :class="{ 'is-invalid': errors['start_date'] }" :config="flatPickr" v-model="data.startDate" />
                <span class="invalid-feedback" role="alert" v-if="errors['start_date']">
                    <strong>{{ errors['start_date'][0] }}</strong>
                </span>
                <input type="time" class="form-control" :class="{ 'is-invalid': errors['start_time'] }" v-model="data.startTime">
                <span class="invalid-feedback" role="alert" v-if="errors['start_time']">
                    <strong>{{ errors['start_time'][0] }}</strong>
                </span>
            </div>
        </div>

        <div class="col-12 mb-5">
            <label class="form-label" for="end_date">
                {{ $trans.get('__JSON__.End Date and Time') }}
            </label>
            <div class="input-group">
                <flat-pickr id="end_date" class="form-control" :class="{ 'is-invalid': errors['end_date'] }" :config="flatPickr" v-model="data.endDate" />
                <span class="invalid-feedback" role="alert" v-if="errors['end_date']">
                    <strong>{{ errors['end_date'][0] }}</strong>
                </span>
                <input type="time" class="form-control" :class="{ 'is-invalid': errors['end_time'] }" v-model="data.endTime">
                <span class="invalid-feedback" role="alert" v-if="errors['end_time']">
                    <strong>{{ errors['end_time'][0] }}</strong>
                </span>
            </div>
        </div>

        <div class="col-12 mb-5">
            <label class="form-label" for="job">
                {{ $trans.get('__JSON__.Job and Slots Available') }}
            </label>
            <div class="input-group">
                <input type="text" id="job" class="form-control" :class="{ 'is-invalid': errors['job'] }" :placeholder="$trans.get('__JSON__.Job Title')" v-model="data.job">
                <span class="invalid-feedback" role="alert" v-if="errors['job']">
                    <strong>{{ errors['job'][0] }}</strong>
                </span>
                <input type="number" class="form-control" :placeholder="25" min="1" v-model="data.slots" disabled>
            </div>
        </div>

        <div class="col-12 mb-5">
            <label class="form-label" for="note">
                {{ $trans.get('__JSON__.Notes') }} ({{ $trans.get('__JSON__.optional') }})
            </label>
            <textarea id="note" cols="30" rows="10" class="form-control" v-model="data.note" :class="{ 'is-invalid': errors['notes'] }"></textarea>
            <span class="invalid-feedback" role="alert" v-if="errors['notes']">
                <strong>{{ errors['notes'][0] }}</strong>
            </span>
        </div>
    </div>
</template>

<script>
import ModalHelper from '../mixins/ModalHelper'
import RequestHandler from '../mixins/RequestHandler'
import ScheduleHelpers from '../mixins/ScheduleHelpers'
import DateHelpers from '../mixins/DateHelpers'
import DatePicker from '../mixins/DatePicker'

export default {
    name: 'EditShift',
    props: {
        department: {
            type: Object,
            required: true,
        },
        shift: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
    },
    mixins: [ModalHelper, RequestHandler, ScheduleHelpers, DateHelpers, DatePicker],
    data() {
        return {
            disabled: true,
            confirmed: false,
            slots: 0,
            reason: null,
            data: {
                id: this.shift.id,
                startDate: this.dateFormat(this.shift.details.start, 'yyyy-MM-dd'),
                startTime: this.dateFormat(this.shift.details.start, 'HH:mm'),
                endDate: this.dateFormat(this.shift.details.end, 'yyyy-MM-dd'),
                endTime: this.dateFormat(this.shift.details.end, 'HH:mm'),
                job: this.shift.details.job,
                slots: this.shift.details.slots.base,
                note: this.shift.details.note,
            },
        }
    },
    watch: {
        disabled() {
            this.$parent.$data.disableSave = this.disabled
        },
        slots() {
            this.checkSave()
        },
        confirmed() {
            this.checkSave()
        },
    },
    methods: {
        save() {
            if (this.shift.has_future_shifts) {
                this.confirmModal('shift_details_modal', [
                    {
                        label: this.$trans.get('__JSON__.Update all future shifts'),
                        variant: 'outline-primary',
                        onClick: async () => {
                            this.submit(this.shift.parent_id, this.shift.id)
                            await this.closeConfirm('shift_details_modal')
                        }
                    },
                    {
                        label: this.$trans.get('__JSON__.Update this shift only'),
                        variant: 'primary',
                        onClick: async () => {
                            this.submit(this.shift.id)
                            await this.closeConfirm('shift_details_modal')
                        }
                    },
                ], this.$trans.get('__JSON__.Edit Shift'), this.$trans.get("__JSON__.Make a choice if you'd like to update only this shift or all future shifts as well. Any differences made from this point in time will be overwritten."))
                return
            }

            this.submit(this.shift.id)
        },
        submit(shiftId, pointer = null) {
            this.disabled = true
            this.makeRequest('post', `/api/shifts/${shiftId}/edit`, {
                start_date: this.data.startDate,
                start_time: this.data.startTime,
                end_date: this.data.endDate,
                end_time: this.data.endTime,
                job: this.data.job,
                note: this.data.note,
                pointer,
            }, response => {
                this.$parent.stopEditing()
            }, error => {
                // on purpose
            }, () => this.disabled = false)
        },
        checkSave() {
            if (this.slots > 0) this.disabled = false
            else if (this.slots < 0 && ! this.confirmed) this.disabled = true
            else this.disabled = this.slots === 0
        },
    },
    mounted() {
        this.disabled = false
    },
    beforeUnmount() {
        this.disabled = true
    },
}
</script>
